import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useTable, useSortBy } from 'react-table'
import { ThemeContext } from 'styled-components'
import { Flex } from 'reflexbox/styled-components'

import { ChevronDown as ChevronDownIcon, ChevronUp as ChevronUpIcon } from 'components/Icons'

import { CardContainer, TableContainer, TableHeader, TableRow, TableCell, TableBody } from './styles'

const SimpleListingTable = ({ columns, data }) => {
  const theme = useContext(ThemeContext)
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    useSortBy,
  )

  return (
    <Flex flex='1' flexDirection='column'>
      <CardContainer>
        <TableContainer {...getTableProps()}>
          <TableHeader>
            {headerGroups.map(headerGroup => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <TableCell
                    as='th'
                    {...column.getHeaderProps(
                      column.getSortByToggleProps(
                        column.canSort && { title: `Ordenar por ${column.render('Header')}` },
                      ),
                    )}
                  >
                    {column.render('Header')}
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <ChevronDownIcon color={theme.colors.grays.N600} />
                      ) : (
                        <ChevronUpIcon color={theme.colors.grays.N600} />
                      )
                    ) : null}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row)
              return (
                <TableRow {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </TableContainer>
      </CardContainer>
    </Flex>
  )
}

SimpleListingTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired,
    }),
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default SimpleListingTable
